import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { getUserList, removeCustomer } from "../../../services/ApiService";
import { goToPage, promptMessage } from "../../../utils/functions";
import { translate } from "../../../utils/translate";
import CustomTable from "../../components/CustomTable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";

const MemberList = (props) => {
    const lang = props.lang;
    const tableColumns = [
        {
            Header: translate(lang, 'index'),
            accessor: (row, index) => {
                return index + 1;
            }
        },
        {
            Header: translate(lang, 'fullName'),
            accessor: (row, index) => {
                return row.fullName ?? "";
            }
        },
        {
            Header: translate(lang, 'agent'),
            accessor: (row, index) => {
                return row.agentInCharge?.fullName;
            }
        },
        {
            Header: translate(lang, 'phone'),
            accessor: (row, index) => {
                return row.phoneCode + " " + row.phone;
            },
            Cell: (props) => {
                return <><span className="text-nowrap">{props.cell.value}</span></>
            }
        },
        {
            Header: translate(lang, 'email'),
            accessor: (row, index) => {
                return row.email
            }
        },
        {
            Header: translate(lang, 'gender'),
            accessor: (row, index) => {
                return row.gender && row.gender !== "null" ? row.gender : "";
            },
            Cell: (props) => {
                return (<><span className="text-capitalize">{props.cell.value}</span></>)
            }
        },
        {
            Header: translate(lang, 'status'),
            accessor: (row, index) => {
                return row.status;
            },
            Cell: ({ value }) => (
                <span className="text-primary">{value}</span>
            )
        },
        {
            Header: translate(lang, 'action'),
            accessor: (row, index) => {
                return (<div className="d-flex flex-nowrap">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-2">{translate(props.lang, "View Customer")}</Tooltip>}
                    >
                        {({ ref, ...triggerHandler }) => (
                            <div
                                ref={ref} {...triggerHandler}
                                onClick={()=>goToPage(`/member/view/${row.id}`, pageNumber, productPerpage, filterInput)}
                                className="btn btn-info shadow btn-xs sharp me-1"
                            >
                                <i className="fas fa-eye"></i>
                            </div>
                        )}
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-3">{translate(props.lang, "Edit Customer Info")}</Tooltip>}
                    >
                        {({ ref, ...triggerHandler }) => (
                            <div
                                ref={ref} {...triggerHandler}
                                onClick={()=>goToPage(`/member/edit/${row.id}`, pageNumber, productPerpage, filterInput)}
                                // to={`/member/edit/${row.id}`}
                                className="btn btn-warning shadow btn-xs sharp me-1"
                            >
                                <i className="fas fa-edit"></i>
                            </div>
                        )}
                    </OverlayTrigger>

                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-4">{translate(props.lang, "Create Customer Policy")}</Tooltip>}
                    >
                        {({ ref, ...triggerHandler }) => (
                            <div
                                ref={ref} {...triggerHandler}
                                onClick={()=>goToPage(`/member/policy/create/${row.id}`, pageNumber, productPerpage, filterInput)}
                                className="btn btn-secondary shadow btn-xs sharp me-1"
                            >
                                <i className="fas fa-plus"></i>
                            </div>
                        )}
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-5">{translate(props.lang, "Edit Customer Policy")}</Tooltip>}
                    >
                        {({ ref, ...triggerHandler }) => (
                            <div
                                ref={ref} {...triggerHandler}
                                onClick={()=>goToPage(`/member/policy/edit/${row.id}`, pageNumber, productPerpage, filterInput)}
                                className="btn btn-success shadow btn-xs sharp me-1"
                            >
                                <i className="fas fa-file"></i>
                            </div>
                        )}
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-5">{translate(props.lang, "Delete Customer")}</Tooltip>}
                    >
                        {({ ref, ...triggerHandler }) => (
                            <span
                                ref={ref} {...triggerHandler}
                                onClick={() => removeItem(row.id)}
                                className="btn btn-danger shadow btn-xs sharp"
                            >
                                <i className="fas fa-trash"></i>
                            </span>
                        )}
                    </OverlayTrigger>
                </div>)
            }
        },
    ]
    const history = useHistory();
    const location = useLocation();
    const [data, setData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [productPerpage, setProductPerpage] = useState(10);
    const [filterInput, setFilterInput] = useState(""); 
    const [fileData, setFileData] = useState({
        name: "member_list_report",
        excelData: [],
        hasCustom: false,
        customRows: [{
            customData: [],
            origin: -1, // last row or specified location like 'A1'
        }],
    });

    useEffect(() => {
        getList()
    }, [])

    async function getList() {
        let query = { isAgent: 0 };
        let res = await getUserList(query);
        if (res?.status === 'success') {
            setData([...res.data])
            setFileData({ ...fileData, excelData: [...res.data] })
        } else {
        }
    }

    function removeItem(id) {
        Swal.fire({
            title: translate(props.lang, "deleteConfirmation"),
            text: translate(props.lang, "deleteMessage"),
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                let res = await removeCustomer(id)
                if (res.status === 'success') {
                    promptMessage(lang, 'success', res.message)
                    getList();
                } else {
                    promptMessage(lang, 'error', res.message)
                    getList();
                }
            }
        })
    }

    // const goToPage = (page) => {
    //     let url = page;
    //     let arr = []
    
    //     if (pageNumber) {
    //       arr.push(`page=${pageNumber}`)
    //     }
    //     if (productPerpage) {
    //       arr.push(`limit=${productPerpage}`)
    //     }

    //     if (keyword) {
    //         arr.push(`keyword=${keyword}`)
    //       }
    //     if (arr.length > 0) {
    //       url = url + `?${arr.join('&')}`
    //     }
    //     window.location.href = url;
    // }

    return (
        <>
            <div className="card shadow">
                <div className="card-header">
                    <div>
                        <h3>{translate(lang, 'member')}</h3>
                    </div>
                    <div>
                        <div  onClick={()=>goToPage(`/member/create`, pageNumber, productPerpage, filterInput)} className="btn btn-sm btn-primary rounded-2 py-2" >{translate(lang, 'createMember')}</div>
                        {/* <button className="btn btn-sm btn-primary" onClick={() => createMember()}>{translate(lang, 'createMember')}</button> */}
                    </div>
                </div>
                <div className="card-body">
                    <div id="job_data" className="dataTables_wrapper">
                        <CustomTable
                            lang={lang}
                            columns={tableColumns}
                            data={data}
                            excelExport={true}
                            fileData={fileData}
                            updatePageNumber={(page) => setPageNumber(page+1)}
                            updatePageLimit={(limit) => setProductPerpage(limit)}
                            pageNumber={pageNumber}
                            pageLimit={productPerpage}
                            goToPage={()=> goToPage(pageNumber)}
                            history={history}
                            location={location}
                            updateFilter={(value) => setFilterInput(value)}
                            filterInput={filterInput}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}


const mapStateToProps = (state) => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
};


export default connect(mapStateToProps)(MemberList);